import { Routes } from "@angular/router";
import { DirtyGuard } from "~app/common/guards/dirty.guard";
import { RaskRoller } from "~app/common/models/constants";
import { kontraktstypGuard } from "~app/features/guards/kontraktstyp.guard";
import { SkogsvardFPVAvtalComponent } from "~app/features/skogsvardfpv/avtal/rask-skogsvard-fpv-avtal.component";
import { ExternVirkeskopSearchComponent } from "~app/features/virkeskop/extern-virkeskop/extern-virkeskop-search/extern-virkeskop-search.component";
import { ForkalkylsmallarComponent } from "~app/features/virkeskop/forkalkylsmallar/forkalkylsmallar.component";
import { FristaendeVirkeskopsKartaComponent } from "~app/features/virkeskop/fristaende-virkeskopskarta/fristaende-virkeskopskarta.component";
import { KontraktExternComponent } from "~app/features/virkeskop/kontrakt-extern/kontrakt-extern.component";
import { virkeskopskontraktSearchParamsResolver } from "~app/features/virkeskop/kontrakt-extern/virkeskopskontrakt-search-params.resolver";
import { MarknadsprislistaComponent } from "~app/features/virkeskop/marknadsprislista/marknadsprislista.component";
import { MinaHandelssortimentComponent } from "~app/features/virkeskop/mina-handelssortiment/mina-handelssortiment.component";
import { VirkesleverantorComponent } from "~app/features/virkeskop/virkesleverantor/virkesleverantor.component";
import { VirkesleverantorResolver } from "~app/features/virkeskop/virkesleverantor/Virkesleverantor.resolver";
import { withPermissions } from "~app/role-permissions";
import { AnbudKontraktComponent } from "../features/virkeskop/anbud-kontrakt/anbud-kontrakt.component";
import { VirkeskopAvtalComponent } from "../features/virkeskop/avtal/virkeskop-avtal.component";

export const virkeskopRoutes: Routes = [
    {
        path: "virkeskop",
        children: [
            {
                path: "avtal",
                title: "Anbud & kontrakt",
                children: [
                    {
                        data: {
                            requiredRoles: [
                                RaskRoller.role.Virkeskopa,
                                RaskRoller.role.Kopplanera,
                                RaskRoller.role.Kopleda,
                                RaskRoller.role.VirkeskopTitta
                            ],
                            editRoles: [
                                RaskRoller.role.Virkeskopa,
                                RaskRoller.role.Kopleda,
                                RaskRoller.role.Kopplanera
                            ],
                            volatileState: "virkeskop"
                        },
                        path: "",
                        component: AnbudKontraktComponent
                    },
                    withPermissions({
                        data: {
                            volatileState: "virkeskop",
                            disableRouteReuseOnChangedParam: "id"
                        },
                        canActivate: [kontraktstypGuard],
                        canDeactivate: [DirtyGuard],
                        path: ":id",
                        component: VirkeskopAvtalComponent,
                        title: "Detaljer",
                        permissions: [
                            {
                                role: RaskRoller.role.Virkeskopa,
                                canEdit: true
                            },
                            {
                                role: RaskRoller.role.Kopplanera,
                                canEdit: true
                            },
                            {
                                role: RaskRoller.role.Kopleda,
                                canEdit: true
                            },
                            {
                                role: RaskRoller.role.VirkeskopTitta,
                                canEdit: false
                            }
                        ]
                    })
                ]
            },
            {
                path: "kontrakt",
                component: KontraktExternComponent,
                resolve: {
                    searchParams: virkeskopskontraktSearchParamsResolver
                },
                data: {
                    requiredRoles: [
                        RaskRoller.role.Virkeskopa,
                        RaskRoller.role.Kopplanera,
                        RaskRoller.role.Kopleda
                    ]
                }
            },
            {
                path: "anbudkontrakt",
                redirectTo: "avtal"
            },
            {
                path: "minahandelssortiment",
                component: MinaHandelssortimentComponent,
                title: "Mina handelssortiment",
                canDeactivate: [DirtyGuard],
                data: {
                    requiredRoles: [
                        RaskRoller.role.Virkeskopa,
                        RaskRoller.role.Kopleda
                    ],
                    editRoles: [
                        RaskRoller.role.Virkeskopa,
                        RaskRoller.role.Kopleda
                    ]
                }
            },
            {
                path: "marknadsprislista",
                title: "Marknadsprislistor",
                canDeactivate: [DirtyGuard],
                component: MarknadsprislistaComponent,
                data: {
                    requiredRoles: [RaskRoller.role.Titta],
                    editRoles: [RaskRoller.role.Prislisteadministrera]
                }
            },
            {
                path: "minaforkalkylsmallar",
                title: "Mina förkalkylsmallar",
                canDeactivate: [DirtyGuard],
                component: ForkalkylsmallarComponent,
                data: {
                    requiredRoles: [RaskRoller.role.Titta],
                    editRoles: [RaskRoller.role.Titta]
                }
            },
            {
                path: "virkeskopkarta",
                title: "Karta",
                component: FristaendeVirkeskopsKartaComponent,
                data: {
                    requiredRoles: [
                        RaskRoller.role.Virkeskopa,
                        RaskRoller.role.Kopleda,
                        RaskRoller.role.VirkeskopTitta
                    ]
                }
            }
        ]
    },
    {
        path: "virkesleverantor",
        title: "Leverantörer",
        children: [
            {
                path: "",
                component: VirkesleverantorComponent,
                data: {
                    requiredRoles: [
                        RaskRoller.role.Virkeskopa,
                        RaskRoller.role.Kopplanera,
                        RaskRoller.role.Kopleda
                    ],
                    editRoles: [
                        RaskRoller.role.Virkeskopa,
                        RaskRoller.role.Kopleda,
                        RaskRoller.role.Kopplanera
                    ],
                    volatileState: "virkeskop"
                }
            },
            {
                path: ":id",
                component: VirkesleverantorComponent,
                data: {
                    requiredRoles: [
                        RaskRoller.role.Virkeskopa,
                        RaskRoller.role.Kopplanera,
                        RaskRoller.role.Kopleda
                    ],
                    editRoles: [
                        RaskRoller.role.Virkeskopa,
                        RaskRoller.role.Kopleda,
                        RaskRoller.role.Kopplanera
                    ]
                },
                resolve: {
                    leverantor: VirkesleverantorResolver
                }
            }
        ]
    },
    {
        path: "virkesleverantor-new",
        redirectTo: "virkesleverantor",
        pathMatch: "full"
    },
    {
        path: "externkontrakt",
        component: ExternVirkeskopSearchComponent,
        title: "Virkeskopskontrakt",
        data: {
            requiredRoles: [
                RaskRoller.role.Virkeskopa,
                RaskRoller.role.Kopleda
            ],
            editRoles: [
                RaskRoller.role.Virkeskopa,
                RaskRoller.role.Kopleda
            ],
            volatileState: "virkeskop"
        }
    },
    {
        path: "skogsvardssp/avtal",
        redirectTo: "skogsvardfpv/avtal",
        pathMatch: "full"
    },
    {
        path: "skogsvardssp/avtal/:id",
        redirectTo: "skogsvardfpv/avtal/:id",
        pathMatch: "full"
    },
    {
        path: "skogsvardfpv",
        children: [
            {
                path: "avtal",
                children: [
                    {
                        path: "",
                        component: SkogsvardFPVAvtalComponent,
                        title: "Sök skogsvårdsuppdrag",
                        canDeactivate: [DirtyGuard],
                        data: {
                            requiredRoles: [RaskRoller.role.Skogsvardsuppdragsplanera],
                            editRoles: [RaskRoller.role.Skogsvardsuppdragsplanera]
                        }
                    },
                    withPermissions({
                        path: ":id",
                        title: "Detaljer",
                        component: VirkeskopAvtalComponent,
                        canDeactivate: [DirtyGuard],
                        canActivate: [kontraktstypGuard],
                        data: {
                            volatileState: "virkeskop",
                            disableRouteReuseOnChangedParam: "id",
                            isSkogsvardFPV: true
                        },
                        permissions: [
                            {
                                role: RaskRoller.role.Skogsvardsuppdragsplanera,
                                canEdit: true
                            }
                        ]
                    })
                ]
            }
        ]
    }

];
